interface Commission {
  id: string;
  lineOfBusiness: string;
  rate: number;
  premiumThresholdMin?: number | null;
  premiumThresholdMax?: number | null;
  appetiteProductId?: string | null;
  notes?: string | null;
}

interface CommissionRatesTableProps {
  commissions: Commission[];
  productNameMap: Map<string, string>;
}

function formatRate(rate: number): string {
  return `${(rate * 100).toFixed(1)}%`;
}

function formatCurrency(value: number): string {
  return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(value);
}

function formatPremiumRange(min?: number | null, max?: number | null): string {
  if (min != null && max != null) {
    return `${formatCurrency(min)} - ${formatCurrency(max)}`;
  }
  if (min != null) {
    return `${formatCurrency(min)}+`;
  }
  if (max != null) {
    return `Up to ${formatCurrency(max)}`;
  }
  return "-";
}

export function CommissionRatesTable({ commissions, productNameMap }: CommissionRatesTableProps) {
  if (commissions.length === 0) {
    return null;
  }

  return (
    <div className="overflow-x-auto rounded-lg">
      <table className="w-full text-sm">
        <thead>
          <tr className="text-left text-muted-foreground">
            <th className="py-1.5 px-2 font-medium">Line of Business</th>
            <th className="py-1.5 px-2 font-medium">Rate</th>
            <th className="py-1.5 px-2 font-medium">Premium Range</th>
            <th className="py-1.5 px-2 font-medium">Product</th>
            <th className="py-1.5 px-2 font-medium">Notes</th>
          </tr>
        </thead>
        <tbody>
          {commissions.map((commission) => (
            <tr key={commission.id} className="border-t border-border/50 first:border-t-0">
              <td className="py-1.5 px-2">{commission.lineOfBusiness}</td>
              <td className="py-1.5 px-2 font-medium">{formatRate(commission.rate)}</td>
              <td className="py-1.5 px-2 text-muted-foreground">
                {formatPremiumRange(commission.premiumThresholdMin, commission.premiumThresholdMax)}
              </td>
              <td className="py-1.5 px-2 text-muted-foreground">
                {commission.appetiteProductId ? (productNameMap.get(commission.appetiteProductId) ?? "-") : "-"}
              </td>
              <td className="py-1.5 px-2 text-muted-foreground">{commission.notes ?? "-"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
